import React from 'react';

export const Logo = ({ style, width = 72, height = 72 }) => (
    <img src="windmar-logo.svg" style={style} width={width} height={height} alt="logo" />
)
